export interface AsyncResult<T> {
    success?: T;
    error?: string;
}

export const DEFAULT_ERROR_MESSAGE = 'Desculpa, um erro inesperado ocorreu, tente novamente.';
